import {addValue} from "../actions";
export const HOST = process.env.NODE_ENV === 'production' ?`${window.location.origin}`: "http://localhost:3000";
export const URL_PREFIX = "/regm";
export const MENTORS_URL = `${URL_PREFIX}/mentors`;

export const FORM_STATUS = {
  0: 'черновик',
  1: 'утверждена',
  2: 'на утверждении',
  3: 'отклонена',
  4: 'отправить в PDF',
  5: 'запрошены документы',
  6: 'на рассмотрении',
  7: 'документы отправлены',
  8: 'отозвана',
  9: 'доп запрос',
  10: 'ожидает отзыва'
};

export const FORM_LABELS = {
  0: 'primary',
  1: 'success',
  2: 'secondary',
  3: 'warning',
  4: 'secondary',
  5: 'secondary',
  6: 'secondary',
  7: 'secondary',
  8: 'warning',
  9: 'secondary',
  10: 'secondary'
};

export const INITIAL_RULES = {
  'set_full_name': {
    valueName: 'ContactFullName',
    callback(dispatch, values) {
      if (typeof SK !== 'undefined'
        && values.filter(value => value.id === 'ContactFullName').length <= 0
      ) {
        const {first_name, last_name, middle_name} = SK.user();
        let value = `${last_name || ''} ${first_name || ''} ${middle_name || ''}`.trim();
        if (value && value.length > 0) {
          dispatch(addValue('ContactFullName', value, false));
        }
      }
    },
  },
  'set_phone': {
    valueName: 'ContactPhone',
    callback(dispatch, values) {
      if (typeof SK !== 'undefined'
        && values.filter(value => value.id === 'ContactPhone').length <= 0
      ) {
        const { phone } = SK.user();
        if (phone && phone.length > 0) {
          dispatch(addValue('ContactPhone', phone, false));
        }
      }
    }
  },
  'set_email': {
    valueName: 'ContactEmail',
    callback(dispatch, values) {
      if (typeof SK !== 'undefined'
        && values.filter(value => value.id === 'ContactEmail').length <= 0
      ) {
        const { email } = SK.user();
        if (email && email.length > 0) {
          dispatch(addValue('ContactEmail', email, false));
        }
      }
    }
  }
};

export const getFormTitle = ({ process_id }) => 'Заявка №' + process_id;
export const getFormSubtitle = ({ typeForm }) => typeForm || '';

export const PAGINATION = {
  page: 1,
  pagesize: 200,
  total: 0,
};
